import { Injectable, Injector } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { HttpInterceptor, HttpHandler, HttpRequest,
         HttpEvent } from '@angular/common/http';
import { Config } from './Services/config';


@Injectable()
export class LangInterceptor implements HttpInterceptor {

  constructor(private inj: Injector) {
  }

  intercept(req: HttpRequest<any>,
            next: HttpHandler): Observable<HttpEvent<any>> {

              let config = this.inj.get(Config);
              // don't use the LanguageService here since it results in a recursive import
              // just look in the localStorage for the preferred Language
              let lang = JSON.parse(localStorage.getItem(config.lang_storage_key));

              if (lang) {

                const cloned = req.clone({
                  headers: req.headers.set(
                    "Accept-Language",
                    lang.id)
                });

                return next.handle(cloned);
              } else {
                return next.handle(req);
              }
            }
}



// WEBPACK FOOTER //
// ./src/app/langinterceptor.ts